import Flickity from 'flickity'
import { parseJSON } from '@/components/helpers/utils'
const defaultOptions = {
  contain: true
}
export class Carousel extends HTMLElement {
  connectedCallback() {
    const options = this.carouselSettings
    options.cellSelector = '&:not(style)'
    this.flickity = new Flickity(this, { ...defaultOptions, ...options })

    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)

    this.visibilityObserver = new MutationObserver(() => {
      if (this.isVisible() && this.flickity) {
        this.flickity.resize()
      }
    })

    this.visibilityObserver.observe(this, {
      attributes: true,
      attributeFilter: ['data-hidden', 'hidden', 'style']
    })

    let parent = this.parentElement
    while (parent && parent !== document.body) {
      this.visibilityObserver.observe(parent, {
        attributes: true,
        attributeFilter: ['data-hidden', 'hidden', 'style']
      })
      parent = parent.parentElement
    }
  }

  isVisible() {
    const thisDataHidden = this.getAttribute('data-hidden')
    if (thisDataHidden === 'true' || this.hidden || this.style.display === 'none') {
      return false
    }

    let parent = this.parentElement
    while (parent && parent !== document.body) {
      const dataHidden = parent.getAttribute('data-hidden')
      if (dataHidden === 'true' || parent.hidden || parent.style.display === 'none') {
        return false
      }
      parent = parent.parentElement
    }
    return true
  }

  observedAttributes = ['carousel-settings']

  get carouselSettings() {
    const carouselSettings = this.getAttribute('carousel-settings')
    if (!carouselSettings) return {}
    const parsedSettings = parseJSON(carouselSettings)
    // Handle groupCells value conversion
    if (parsedSettings?.groupCells !== undefined) {
      const value = parsedSettings.groupCells

      // Convert string 'true'/'false' to boolean
      if (value === 'true') {
        parsedSettings.groupCells = true
      } else if (value === 'false') {
        parsedSettings.groupCells = false
        // Convert numeric string to number
      } else if (!isNaN(value) && typeof value === 'string') {
        parsedSettings.groupCells = Number(value)
      }
    }
    return parsedSettings
  }

  handleResize() {
    if (this.flickity) {
      this.flickity.resize()
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize)
    if (this.visibilityObserver) {
      this.visibilityObserver.disconnect()
    }
    if (this.flickity) {
      this.flickity.destroy()
    }
  }
}
